var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container my-4"},[_c('div',{staticClass:"text-center"},[_vm._m(0),_c('button',{staticClass:"btn btn-outline-danger py-2 px-5 blackbutton fs-6",on:{"click":_vm.goBack}},[_vm._v(" GO Back ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"py-4"},[_c('span',{staticClass:"text-danger font-bold"},[_vm._v("404")]),_vm._v(" "),_c('br'),_vm._v(" Page not Found ")])
}]

export { render, staticRenderFns }